import cartActionTypes from './actionTypes';
import cartItemActionTypes from '../cartItems/actionTypes';
import pricingActionTypes from '../pricing/actionTypes';
import createReducer from '../utils/createReducer';

const defaultState = {
  isLoaded: false,
  isOutdated: false,
  cartId: null,
  tenant: undefined,
  shopperId: undefined,
  legalRequirements: [],
  checkoutValidity: {
    validityChecks: [],
  },
  pendingItemsCount: 0,
  pendingItemSummaries: [],
  vistaCartUrl: undefined,
  pendingOperations: [],
  pendingOperationReloadAttemptCount: 0,
};

export default createReducer(defaultState)({
  [cartActionTypes.CART_LOAD_START]: (state, action) => ({
    ...state,
    isLoaded: false,
  }),
  [cartActionTypes.CART_LOAD_SUCCESS]: (state, action) => ({
    ...state,
    isLoaded: true,
    isOutdated: false,
    cartId: action.cart.id,
    tenant: action.tenant,
    shopperId: action.shopperId,
    legalRequirements: action.customOrderData?.legalRequirements || [],
    checkoutValidity: action.cart.checkoutValidity,
    pendingItemsCount: action.cart.pendingItemsCount,
    pendingItemSummaries: action.cart.pendingItemSummaries,
    vistaCartUrl: action.cart.vistaCartUrl,
    pendingOperations: action.cart.pendingOperations || [],
    lastModifiedDate: action.cart.lastModifiedAt,
  }),
  [cartActionTypes.CART_CLEAR]: (state, action) => defaultState,
  [cartActionTypes.CART_LOAD_FAIL]: (state, action) => ({
    ...state,
    error: action.error,
  }),
  [cartItemActionTypes.CARTITEMS_REMOVE_SUCCESS]: state => ({
    ...state,
    isOutdated: true,
  }),
  [cartItemActionTypes.CARTITEMGROUP_REMOVE_SUCCESS]: state => ({
    ...state,
    isOutdated: true,
  }),
  [cartItemActionTypes.CARTITEMS_QUANTITY_UPDATE_SUCCESS]: state => ({
    ...state,
    isOutdated: true,
  }),
  [pricingActionTypes.CLEAR_COUPON_SUCCESS]: (state, action) => ({
    ...state,
    isOutdated: true,
  }),
  [pricingActionTypes.SET_COUPON_SUCCESS]: (state, action) => ({
    ...state,
    isOutdated: true,
  }),
  [cartActionTypes.CART_CHANGED_EXTERNALLY]: state => ({
    ...state,
    isOutdated: true,
  }),
  [cartActionTypes.INCREMENT_PENDING_OPERATION_RELOAD_ATTEMPTS]: state => ({
    ...state,
    pendingOperationReloadAttemptCount:
      state.pendingOperationReloadAttemptCount + 1,
  }),
  [cartActionTypes.RESET_PENDING_OPERATION_RELOAD_ATTEMPTS]: state => ({
    ...state,
    pendingOperationReloadAttemptCount: 0,
  }),
});
